export default "__VITE_ASSET__5c271c33__"